<template>
  <quill-editor id="editor-container"
                ref="myTextEditor"
                v-model="content"
                :options="editorOption"
                @change="onEditorChange()"></quill-editor>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
export default {
  components: {
    quillEditor,
  },
  created() {
    this.bus.$on('clearData', () => {
      this.content = '';
    });
  },
  data() {
    return {
      content: '',
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],
            ['clean'], // remove formatting button
          ],
        },
      },
    };
  },
  props: ['bus'],
  methods: {
    onEditorChange() {
      this.$emit('updateMailContent', this.content);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/mail/TextEditor.vue